import { Badge } from '@/components/ui/badge';
import { ProductDetailsAccordion, type ProductWithPimAttributes } from './product-details-accordion';

type Product = ProductWithPimAttributes;

export default function ProductTabsDetails({ product }: { product: Product }) {
    const productHighlight = product.c_pimProductHighlights;
    const productDescription = product.longDescription;

    return (
        <div className="grid-global lg:justify-between !px-0">
            <div className="col-span-6 lg:col-span-7 flex flex-col gap-4">
                <div className="flex flex-wrap gap-2">
                    {productHighlight ? (
                        <Badge hierarchy="secondary" schema="default" className="max-w-full" title={productHighlight}>
                            <span className="truncate">{productHighlight}</span>
                        </Badge>
                    ) : null}
                </div>
                {productDescription && (
                    <div
                        className="prose prose-sm max-w-none marker:text-black [&_ul]:list-disc [&_ul]:pl-5"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: productDescription }}
                    />
                )}
            </div>
            <div className="col-span-full lg:col-span-4 lg:col-end-13">
                <ProductDetailsAccordion product={product} />
            </div>
        </div>
    );
}
